// Can be later extended to include everything to create the table automatically
// e.g. the columns definition array with callback functions

import { SortEvent } from 'primeng/api';

export interface TableConfigurationSettings {
  tableCollapsable?: boolean;
  exportEnabled?: boolean; // We force the parent component to set the export filename if the export should be enabled
  settingsEnabled?: boolean; // The settings can be enabled independent if they are saved to the db
  settingsKeepFilters?: boolean; // If the table-filters should be saved or not
  settingsKeepRows?: boolean; // If the 'items per page' should be saved or not
  settingsDbIdentifier?: string; // Only if we use an identifier it is saved in SCIP Backend DB
  refreshEnabled?: boolean; // Indicates whether to enable the refresh functionality of the table
}

export interface TableConfiguration {
  headerIcon?: string;
  headerText?: string; // Better use headerText-Input on avano-table directly
  headerTextDescription?: string;
  tableSettings?: TableConfigurationSettings;
  useTableDefaults?: boolean;
  withPagination?: boolean;
}

export interface TableColumnConfiguration {
  header: string;
  field: string;
  filterable?: boolean;
  filterConfiguration?: TableColumnFilterConfiguration;
  sortable?: boolean;
  sortField?: string; // needed if we sort on a different field than the field which is shown
  width?: string;
  minWidth?: string;
  show?: boolean;
  userHidden?: boolean; // Can the user toggle the visibility or is it controlled by code only
  excludeExcel?: boolean;
  minInputLength?: number;
}

export interface TableColumnFilterConfiguration {
  filterField?: string; // needed if we filter on a different field than the field which is shown
  filterMode?: TableColumnFilterMode;
  values?: any;
  isSingleSelectLabelField?: any;
  valuesLabel?: string; // If the values are an array of objects, the field of the object is displayed which is set here
}

export enum TableColumnFilterMode {
  AUTOCOMPLETE_SINGLE = 'AutocompleteSingle',
  AUTOCOMPLETE_MULTIPLE = 'AutocompleteMultiple',
  DATEPICKER_SINGLE = 'DatepickerSingle',
  PLAINTEXT = 'Plaintext' // Used as default
}

export enum TableColumnFilterMatchMode {
  INCLUDES = 'INCLUDES',
  EXCLUDES = 'EXCLUDES'
}

export interface TableTemplateTypes<T> {
  header: { $implicit: TableColumnConfiguration[] };
  body: {
    $implicit: T;
    columns: TableColumnConfiguration[];
  };
}

export interface TypedSortEvent<T> extends SortEvent {
  data: T[];
  sortMode: 'single' | 'multiple';
}
